import style from './../Report.module.scss';
import {FaSitemap} from 'react-icons/fa';
import moment from 'moment';
import ReportTypeStructure from '../ReportTypeStructure';
import ClinicsStatsTable from './ClinicsStatsTable/ClinicsStatsTable';

const DistributorClinicsReport = ({report, isStandalone}) => {
    const {data} = report;
    const {distributor, clinics} = data;

    const getHeader = () => {
        return (
            <div className='d-flex'>
                <div>
                    <h1>{distributor.name}: Distributor Clinics Report</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <h5>Clinics Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.col6].join(' ')} style={{minHeight: 300}}>
                            <ClinicsStatsTable isStandalone={isStandalone} clinics={clinics} />
                        </div>
                    </div>
                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={getHeader()} content={getContent()} />
    )
}

export default DistributorClinicsReport;